module.exports = __webpack_public_path__ + "img/cn_zl_2004.968038bf.jpg";